import styled from 'styled-components';

import { breakpoints, colors, fontFamily } from '../../ui/variables';

export const HistogramGalleryStyle = styled.div`
  &.gallery-item-size-small,
  &.gallery-item-size-medium {
    @media (min-width: ${breakpoints.hd.width}px) {
      display: flex;
      flex-wrap: wrap;
    }

    .histogram-item {
      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: calc(50% - 8px);
      }

      &:nth-child(2n + 1) {
        @media (min-width: ${breakpoints.hd.width}px) {
          margin-right: 8px;
        }
      }

      &:nth-child(2n + 2) {
        @media (min-width: ${breakpoints.hd.width}px) {
          margin-left: 8px;
        }
      }
    }
  }

  &.gallery-item-size-small {
    .histogram-item {
      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        flex-basis: 33.33%;
      }

      &:nth-child(2n + 1) {
        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          margin-right: initial;
        }
      }

      &:nth-child(2n + 0) {
        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          margin-left: initial;
        }
      }

      &:nth-child(3n + 1) {
        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          flex-basis: calc(33.33% - 8px);
          margin-right: 8px;
        }
      }

      &:nth-child(3n + 2) {
        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          flex-basis: calc(33.33% - 16px);
          margin-left: 8px;
          margin-right: 8px;
        }
      }

      &:nth-child(3n + 3) {
        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          flex-basis: calc(33.33% - 8px);
          margin-left: 8px;
        }
      }
    }
  }

  .histogram-item {
    background-color: ${colors.mostlyWhite};
    border-radius: 12px;
    margin-bottom: 8px;
    padding-top: 12px;
    width: 100%;

    @media (min-width: ${breakpoints.hd.width}px) {
      margin-bottom: 16px;
    }

    &.high-histogram {
      .histogram-title {
        &:after {
          background-color: ${colors.softYellow};
        }
      }
    }

    &.low-histogram {
      .histogram-title {
        &:after {
          background-color: ${colors.softRed};
        }
      }
    }

    &.normal-histogram {
      .histogram-title {
        &:after {
          background-color: ${colors.softBlue};
        }
      }
    }

    .histogram-title {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGrayishBlue};
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 20px;
      padding: 0 20px 0 120px;
      position: relative;

      &:after {
        content: '';
        display: block;
        height: 16px;
        left: 96px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
      }
    }
  }

  .chart-label {
    ${fontFamily.sourceSansPro.bold};
    color: ${colors.grayishBlue};
    font-size: 14px;
    line-height: 18px;
    position: absolute;
    width: fit-content;

    &.label-x {
      bottom: -52px;
      left: 50%;
      transform: translateX(-50%);
    }

    &.label-y {
      left: -112px;
      top: 50%;
      transform: translateY(-50%) rotate(-90deg);
    }
  }
`;
